module.exports = __webpack_public_path__ + "img/Screenshot_5.771e8ebf.png";